import script from "./UserEditDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserEditDialog.vue?vue&type=script&lang=ts&setup=true"

import "./UserEditDialog.vue?vue&type=style&index=0&id=79079c32&lang=scss"

const __exports__ = script;

export default __exports__